import MandatoryUserAgreement from "../../../components/MandatoryUserAgreement";
import EmailSection from "../Sections/EmailSection";
import BirthdaySection from "../Sections/BirthdaySection";
import UserAgreementSection from "../Sections/UserAgreementSection";
import ISection from "../Sections/ISection";
import RestPromise from "../../../utils/RestPromise";
import { TInformationPageTranslation } from "../../../Support/Types/TInformationPageTranslation";
import MSignup from "../Models/MSignup";
import VSignup from "../Views/VSignup";

export default class CSignup {
  private readonly view: VSignup;
  private readonly model: MSignup;
  private readonly _userAgreementSection: UserAgreementSection;
  private readonly _emailSection: EmailSection;

  constructor() {
    this.view = new VSignup();
    this._sections.push(new BirthdaySection());
    this._userAgreementSection = new UserAgreementSection();
    this._emailSection = new EmailSection();
    this._sections.push(this._userAgreementSection);
    this._sections.push(this._emailSection);
    this.model = new MSignup(this.view);

    new MandatoryUserAgreement();

    const inputs = $("input");
    for (let i = 0; i < inputs.length; i += 1) {
      if ($(inputs[i]).val() !== "") {
        $(inputs[i]).trigger("focusout");
      }
    }

    this.sections.forEach((section) => {
      section.onChange = this.OnValidationChange.bind(this);
    });

    this.emailSection.onEmailValid = this.updateUserAgreementToSign.bind(this);
    if (!this.emailSection.isEmpty) {
      this.updateUserAgreementToSign(this.emailSection.address);
    }

    this.view.submit.on("click", (event) => {
      event.preventDefault();
      if (!this.model.submitEnabled) {
        this._sections.forEach((section) => {
          section.CheckValidity();
        });
      } else {
        this._userAgreementSection.Show();
      }
    });

    this.view.acceptButton.on("click", () => {
      if (this.model.submitted) {
        return;
      }

      this.view.form.trigger("submit");
      this.model.submitted = true;
    });

    this.view.form.on("keyup keypress blur change", () => {
      this.OnValidationChange();
    });

    this.OnValidationChange();
  }

  public get userAgreementSection(): UserAgreementSection {
    return this._userAgreementSection;
  }

  private _sections: ISection[] = [];

  public get sections(): ISection[] {
    return this._sections;
  }

  public get emailSection(): EmailSection {
    return this._emailSection;
  }

  public OnValidationChange(): void {
    this.model.submitEnabled = true;
    this.sections.forEach((section) => {
      if (!section.isValid) {
        this.model.submitEnabled = false;
      }
    });
    this.model.submitEnabled =
      this.model.submitEnabled && !this.view.form.is(":invalid");
  }

  private updateUserAgreementToSign(email: string): void {
    this.userAgreementSection.translation = null;
    RestPromise.Create(
      `/rest/information-page/user-agreement/${email}`,
      "GET",
    ).then((result: TInformationPageTranslation) => {
      this.userAgreementSection.translation = result;
      this.OnValidationChange();
    });
  }
}

$(window).on("load", () => {
  new CSignup();
});
